import List from "./List"
import styles from "./Posts.module.scss"

export default function Posts({ items }) {
  return (
    <div className={styles.posts}>
      <List items={items}></List>
    </div>
  )
}
